import React from "react";
import CardBody from "../../../components/Card/CardBody";
import { GridLegacy } from "@mui/material";
import Card from "../../../components/Card/Card";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";

function Ayce() {
  const { menukaartVestigingId } = useFormContext();
  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody>
          <GridLegacy container spacing={1}>
            <FormControlledInputTC
              name={"ayceTTL"}
              rules={{
                min: {
                  value: 0,
                  message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                },
              }}
              suffix={" min"}
              tDefault={"Dining time"}
              tKey={"producten.form.ayce.ayceTTL"}
              type={"number"}
            />
            <FormControlledInputTC
              name={"ayceRounds"}
              rules={{
                min: {
                  value: 0,
                  message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                },
              }}
              tDefault={"Order rounds"}
              tKey={"producten.form.ayce.ayceRounds"}
              type={"number"}
            />
            <FormControlledInputTC
              name={"ayceItemsPp"}
              rules={{
                min: {
                  value: 0,
                  message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                },
              }}
              tDefault={"Items p.p."}
              tKey={"producten.form.ayce.ayceItemsPp"}
              type={"number"}
            />
            <FormControlledInputTC
              name={"aycePauzeBetFood"}
              rules={{
                min: {
                  value: 0,
                  message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                },
              }}
              suffix={" min"}
              tDefault={"Pauze between food"}
              tKey={"producten.form.ayce.aycePauzeBetFood"}
              type={"number"}
            />
            <FormControlledInputTC
              name={"aycePauzeBetDrinks"}
              rules={{
                min: {
                  value: 0,
                  message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                },
              }}
              suffix={" min"}
              tDefault={"Pauze between drinks"}
              tKey={"producten.form.ayce.aycePauzeBetDrinks"}
              type={"number"}
            />
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Arrangementen"} tKey={"producten.arrangementen.header"} />
              </h3>
            </GridLegacy>
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"hideArrangement" + menukaartVestigingId}
              multiple={true}
              name={"hideArrangement"}
              tDefault={"Selecteer een Arrangement(en)"}
              tKey={"producten.form.extra.taglist.showArrangement.headerText"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Ayce;
